/* src/modules/discounts/Scene.js */

import React from 'react';
// import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import DiscountsCard from './cards/DiscountsCard';
import ViewOwnerCard from './cards/ViewOwnerCard';

class Discounts extends React.Component {
  lol() {}

  render() {
    return (
      <Grid container spacing={16}>
        <Grid item xs={12} md={6}>
          <DiscountsCard innerRef={node => this.list = node} />
        </Grid>
        <Grid item xs={12} md={6}>
          {/* eslint-disable-next-line */}
          <ViewOwnerCard fetchOwners={() => this.list.getWrappedInstance()._onFetchDiscountHolders({})} />
        </Grid>
      </Grid>
    );
  }
}

const styles = () => ({ });

export default withStyles(styles)(Discounts);



// WEBPACK FOOTER //
// ./src/modules/discounts/Scene.js